import { PayloadAction } from '@reduxjs/toolkit';

import {
  ApiKeyServiceCreateRequest,
  ApiKeyServiceCreateResponse,
} from 'api/auth/api.pb';
import {
  onApiCall,
  onApiCallError,
  onApiCallSuccess,
} from 'app/api/call_status';
import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

export const initialState: ContainerState = {
  apiKeys: {
    loading: false,
    error: null,
    data: [],
  },
  createApiKey: {
    loading: false,
    error: null,
    data: null,
  },
  revokeApiKey: {
    loading: false,
    error: null,
  },
};

const apiKeysSlice = createSlice({
  name: 'apiKeys',
  initialState,
  reducers: {
    getApiKeys(state) {
      onApiCall(state.apiKeys);
    },
    getApiKeysSuccess(state, action: PayloadAction<any>) {
      onApiCallSuccess(state.apiKeys);
      state.apiKeys.data = action.payload.api_keys ?? [];
    },
    getApiKeysError(state, action: PayloadAction<any>) {
      onApiCallError(state.apiKeys, action.payload);
    },

    createApiKey(state, action: PayloadAction<ApiKeyServiceCreateRequest>) {
      onApiCall(state.createApiKey);
      state.createApiKey.data = null;
    },
    createApiKeySuccess(
      state,
      action: PayloadAction<ApiKeyServiceCreateResponse>,
    ) {
      onApiCallSuccess(state.createApiKey);
      state.createApiKey.data = action.payload;
    },
    createApiKeyError(state, action: PayloadAction<any>) {
      onApiCallError(state.createApiKey, action.payload);
    },
    resetCreateApiKey(state) {
      state.createApiKey = initialState.createApiKey;
    },

    revokeApiKey(state, action: PayloadAction<any>) {
      onApiCall(state.revokeApiKey);
    },
    revokeApiKeySuccess(state) {
      onApiCallSuccess(state.revokeApiKey);
    },
    revokeApiKeyError(state, action: PayloadAction<any>) {
      onApiCallError(state.revokeApiKey, action.payload);
    },
  },
});

export const { actions, reducer, name: sliceKey } = apiKeysSlice;
